import { PageHeader } from '../components/AdminPageUI';
import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Paper, Grid } from '@mui/material';
import axios from 'axios';

const initialFees = {
  creche_KG2: '',
  basic1_6: '',
  basic7_9: ''
};

export default function FeedingFeeConfig() {
  const [fees, setFees] = useState(initialFees);

  useEffect(() => {
    axios.get('/api/feeding-config')
      .then(res => setFees(res.data))
      .catch(err => console.error('Fetch failed:', err));
  }, []);

  const handleChange = (e) => {
    setFees({ ...fees, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    axios.put('/api/feeding-config', fees)
      .then(() => alert('Feeding fee config updated successfully.'))
      .catch(err => console.error('Update failed:', err));
  };

  return (
    <Box>
      <PageHeader title="Feeding Fee Configuration" description="Set the daily feeding rates for each school level." />
      <Paper className="workspace-section" elevation={3} sx={{ p: 3, maxWidth: 500 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}  >
            <TextField
              label="Creche – KG2 Fee"
              name="creche_KG2"
              value={fees.creche_KG2}
              onChange={handleChange}
              type="number"
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12 }}  >
            <TextField
              label="Basic 1 – 6 Fee"
              name="basic1_6"
              value={fees.basic1_6}
              onChange={handleChange}
              type="number"
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12 }}  >
            <TextField
              label="Basic 7 – 9 Fee"
              name="basic7_9"
              value={fees.basic7_9}
              onChange={handleChange}
              type="number"
              fullWidth
            />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          sx={{ mt: 3 }}
          onClick={handleSubmit}
        >
          Save Changes
        </Button>
      </Paper>
    </Box>
  );
}
